import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang, IMAGES } from "../i18n";
import { SectionLabel } from "./Motion";
import { ArrowUpRight } from "lucide-react";

export const Sectors = () => {
  const { t } = useLang();
  const s = t.sectors;

  return (
    <section id="sectors" data-testid="sectors-section" className="relative py-20 md:py-32 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-12">
          <SectionLabel>{s.label}</SectionLabel>
          <h2 className="font-cormorant font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[var(--text-primary)]">
            {s.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="sectors-grid">
          {s.items.map((item, i) => {
            const card = (
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                data-testid={`sector-card-${i}`}
                className="group relative h-full overflow-hidden rounded-[1.5rem] border border-[var(--border)] aspect-[4/3]"
              >
                <img
                  src={IMAGES[item.img]}
                  alt={item.t}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)] via-[var(--bg-primary)]/30 to-transparent" />
                <span className="absolute top-5 left-5 w-5 h-5 border-t border-l border-[var(--gold)]/50" />
                {item.link && (
                  <span className="absolute top-5 right-5 w-10 h-10 rounded-full border border-[var(--gold)]/70 bg-[var(--bg-primary)]/40 backdrop-blur-sm flex items-center justify-center text-[var(--gold)] transition-transform duration-500 group-hover:scale-110">
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7">
                  <span className="font-jetbrains text-[11px] tracking-[0.2em] text-[var(--gold)] uppercase">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-cormorant text-2xl md:text-3xl text-[var(--text-primary)] mt-2">{item.t}</h3>
                  <p className="font-outfit font-light text-sm text-[var(--text-secondary)] leading-relaxed mt-2">
                    {item.d}
                  </p>
                  {item.link && (
                    <span className="inline-flex items-center gap-2 mt-4 font-jetbrains text-[10px] tracking-[0.2em] uppercase text-[var(--gold)]">
                      {s.more} <ArrowUpRight className="w-3.5 h-3.5" />
                    </span>
                  )}
                </div>
              </motion.div>
            );
            return item.link ? (
              <Link key={i} to={item.link} data-testid={`sector-link-${i}`} className="block h-full">
                {card}
              </Link>
            ) : (
              <React.Fragment key={i}>{card}</React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};
